<template>
    <div :class="{case: !customise}">
            
        <div :class="[{customise_overlay: customise}, {case_title: !customise}]">
                <router-link :to="show_link ? '/' : '#'" class="logo_link">
                    <img class="logo game_logo" src="/assets/rs-logo.png" alt="RS Components">
                </router-link>
                <div class="expand">
                    <div></div>
                    <div></div>
                </div>
            <h1 v-if="!customise">{{ title }}</h1>
            <p v-if="!customise">{{ description}}</p>
        </div>
        <div class="levels_info" v-if="!customise">
                <div class="lvl lvl_2" v-bind:class="{lvl_active: logistics}">
                        <div class="lvl_icon">
                            <img src="/assets/icons/logistics.svg" alt=""></div>
                        </div>
                <div class="lvl lvl_0" v-bind:class="{lvl_active: lab}">
                        <div class="lvl_icon">
                            <img src="/assets/icons/lab.svg" alt=""></div>
                        </div>
                <div class="lvl lvl_1" v-bind:class="{lvl_active: construction}">
                        <div class="lvl_icon">
                            <img src="/assets/icons/construction.svg" alt=""></div>
                        </div>
                
            </div>
        </div>
</template>

<script>
    export default {
        name: 'AppCase',
        props: {
            sub: {
                required: true,
                type: String,
            },
            title: {
                required: true,
                type: String,
            },
            description: {
                required: true,
                type: String,
            }
        },
        data() {
            return {
                lab: false,
                logistics: false,
                construction: false,
                customise: false,
                show_link: ''
            }
        },
        beforeMount(){
            this.$route.name === 'customise'? (this.customise = true) : null;
            this.$route.name === 'game'? (this.customise = false) : null;
            this.$route.params.level === 'lab'? (this.logistics = true)  && (this.lab = true) : null;
            this.$route.params.level === 'logistics'? (this.logistics = true) : null;
            this.$route.params.level === 'construction'? (this.logistics = true) && (this.lab = true) : null;
            this.$route.params.level === 'construction'? (this.construction = true) : null;
        },
        watch: {
          $route(to) {
            // console.log(to);
            // console.log(from);
            to.name === 'game' ? (this.customise = false) : null;
            to.name === 'customise' ? (this.customise = true) : null;
            to.params.level === 'lab' ? (this.lab = true) : null;
            to.params.level === 'logistics' ? (this.level = true) : null;
            to.params.level === 'construction' ? (this.construction = true) : null;
          }
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
        .nav {
        }
        .customise_overlay {
            position: relative;
            z-index: 4000;
            width: 100%;
            height: 100%;
            background-color: #ffffffe6;
            -webkit-box-flex: 1;
            -ms-flex-positive: 1;
            flex-grow: 1;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            justify-content: center;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            -ms-flex-wrap: wrap;
            flex-wrap: wrap;
        }
        .levels_info{
            height: 50%; 
            width: 100%;
            background-color: white;
            display: flex;
            justify-content: space-between;
        }

        .lvl {
            transition: .3s;
            height: 100%;
            width: 33.33%;
            display: flex; 
            justify-content: center;
            align-items: center;
            opacity: 0.2;
        }

        .lvl_active{
            opacity: 1;
        }

        .lvl_0{
            background-image: url('../../public/assets/lab_ico.jpg');
            background-size: cover;
            background-position: center;        }

        .lvl_1{
            background-image: url('../../public/assets/bui_ico.jpg');
            background-size: cover;
            background-position: center;        }

        .lvl_2{
            background-image: url('../../public/assets/ware_ico.jpg');
            background-size: cover;
            background-position: center;
        }

        .lvl_icon{
            height: 70px;
            width: 70px;
            padding: 20px;
            border-radius: 90px;
            background-color: #fff;
        }
        @media only screen and (max-width: 724px) {
            .lvl_icon{
            height: 60px;
            width: 60px;
            padding: 5px;
            border-radius: 60px;
            background-color: #fff;
            }
        }
        .logo_link {
            padding-bottom: 150px;
            margin: 0 auto;
        }
        .game_logo {
            height: 50px;
            position: absolute;
            left: 30px;
            top: 35px;
        }
        .subtitle {
            margin: 0;
        }
    </style>